import formComponent from '@/util/proto/formComponent'
import { phoneValidator , bankCardValidator } from '@/util/validator'
import { parseDict } from '@/util/dicts'
export default {
  extends: formComponent ,
  components:{ },
  data() {
    return {
      formData: {
        // account: {
        //   rules:[
        //     { required: true, message: '请输入账号', trigger: 'blur,change' },
        //   ]
        // },
        name: {
          rules:[
            { required: true, message: '请输入姓名', trigger: 'blur,change' },
          ]
        },
        phone: {
          rules:[
            { required: true, trigger: 'blur,change' ,validator: phoneValidator('请输入手机号', '请输入正确格式的手机号')},
          ]
        },
        gender:{
          rules:[
            { required: false, type:'number',message: '请选择性别', trigger: 'blur,change' },
          ]
        },
        duties:{
          rules:[
            { required: false, type:'number',message: '请选择职位', trigger: 'blur,change' },
          ]
        },
        organizationId:{
          rules:[
            { required: true,type:'number', message: '请选择单位', trigger: 'blur,change' },
          ]
        },
        idcard:{
          rules:[
            { required: false, message: '请输入警号', trigger: 'blur' },
          ]
        },
        // appSystem:null,
      },
      id:null,
      loading:false,
      roles:[],
      visible:false,
      api:['policemanCreate','policemanUpdate']
    }
  },

  computed:{
    title(){
      return this.id ? '修改警员' : '新增警员'
    },
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if(this.id){
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.policeman(this.id).then(resp => {
        if(resp.data.duties) {
          resp.data.duties = parseDict(resp.data.duties,'job',true)
        }
        this.$setFormData(resp.data)
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }

      params.duties = parseDict(d.duties , 'job')
      params.userType = 10
      return params
    }
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          {/*<sl-form-item label="账号">
            <Input v-decorator={this.formData.account}></Input>
          </sl-form-item>*/}
          <sl-form-item label="姓名">
            <Input v-decorator={this.formData.name}></Input>
          </sl-form-item>
          <sl-form-item label="警号">
            <Input v-decorator={this.formData.idcard}></Input>
          </sl-form-item>
          <sl-form-item label="性别">
            <sl-select dict="gender" type="radio" v-decorator={this.formData.gender} />
          </sl-form-item>
          <sl-form-item label="电话">
            <Input v-decorator={this.formData.phone}></Input>
          </sl-form-item>
          <sl-form-item label="职位">
            <sl-select dict="job" v-decorator={this.formData.duties} />
          </sl-form-item>
          <sl-form-item label="所属单位">
            <sl-select multiple={false} dict="org" v-decorator={this.formData.organizationId} />
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      data: {},
      visible:false,
    }
  },

  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.policeman(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , {'duties':'job','gender':'gender'})
      })
    }
  },

  render(){
    const data = this.data || {}
    //col={3} layout="vertical"

    const title = '查看警员'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-detail-list label-width="110px" col={1} label-align="right" style="padding:12px;">
          {/*<sl-detail-list-item title="账号" content={data.account} />*/}
          
          <sl-detail-list-item title="姓名" content={data.name} />
          
          <sl-detail-list-item title="警号" content={data.idcard} />
          
          <sl-detail-list-item title="性别" content={data.genderText} />
          
          <sl-detail-list-item title="电话" content={data.phone} />
          
          <sl-detail-list-item title="职位" content={data.duties} />
          
          <sl-detail-list-item title="所属单位" content={data.organizationName} />
          
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}
